import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from 'Services/Services';
import { useParams } from 'react-router-dom';

function RiderDetail() {
  const { id } = useParams();
  const [rider, setRider] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ordersLoading, setOrdersLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    const fetchRider = async () => {
      try {
        const riderResp = await axios.get(`${ApiUrl}/rider/${id}`);
        setRider(riderResp.data);
      } catch (error) {
        console.error('Error fetching rider:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRider();
  }, [id]);

  useEffect(() => {
    if (!id) return;

    const fetchOrders = async () => {
      setOrdersLoading(true);
      try {
        const ordersResp = await axios.get(`${ApiUrl}/order/rider/${id}`);
        setOrders(ordersResp.data.data || []); // based on your API response format
      } catch (error) {
        console.error('Error fetching rider orders:', error);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchOrders();
  }, [id]);

  if (loading) return <div>Loading rider info...</div>;
  if (!rider) return <div>No rider found.</div>;

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-lg rounded-xl p-6 space-y-6">
      <h2 className="text-3xl font-bold mb-6">Rider Details</h2>

      <div className="mb-6 space-y-1">
        <p><strong>Name:</strong> {rider.name}</p>
        <p><strong>Username:</strong> {rider.username}</p>
        <p><strong>Vehicle Type:</strong> {rider.vehicleType}</p>
        <p><strong>Phone:</strong> {rider.phone}</p>
        <p><strong>Branch ID:</strong> {rider.branchId}</p>
        <p><strong>Status:</strong> <span className="capitalize">{rider.status}</span></p>
        <p><strong>Order Count:</strong> {rider.orderCount ?? 0}</p>
      </div>

      <hr className="my-6" />

      <h3 className="text-2xl font-semibold mb-4">Assigned Orders ({rider.orderCount ?? 0})</h3>

      {ordersLoading ? (
        <p>Loading orders...</p>
      ) : orders.length === 0 ? (
        <p>No orders assigned to this rider.</p>
      ) : (
        <ul className="space-y-6">
          {orders.map(order => (
            <li key={order.id} className="border p-4 rounded shadow-sm">
              <div className="flex justify-between items-center mb-2">
                <strong className="text-lg">Order #{order.id}</strong>
                <span className="capitalize font-medium">{order.status}</span>
              </div>

              <p><strong>Total Price:</strong> Rs {order.totalPrice}</p>
              <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
              <p><strong>Address:</strong> {order.address}</p>
              <p><strong>Estimated Time:</strong> {order.estimatedTime ?? 'N/A'} mins</p>

              <p className="mt-2"><strong>User:</strong> {order.User?.name} ({order.User?.email})</p>

              <div className="mt-4">
                <strong>Items:</strong>
                <ul className="list-disc list-inside mt-2 space-y-2">
                  {order.items.map(item => (
                    <li key={item.id} className="flex items-center space-x-3">
                      <div>
                        {item.quantity} x {item.food?.name} — ₹{item.price}
                      </div>
                      {item.food?.image && (
                        <img
                          src={item.food.image}
                          alt={item.food.name}
                          className="w-12 h-12 object-cover rounded"
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RiderDetail;
